var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarClosure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200.035538px",
    height: "117.302516px",
    viewBox: "0 0 200.035538 117.302516",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.590602,33.8598329 C187.538993,41.0864816 113.597124,111.527552 113.597124,111.527552 C110.038854,115.217857 105.132889,117.302516 100.006523,117.302516 C94.8801572,117.302516 89.9741914,115.217857 86.4159223,111.527552 C86.4159223,111.527552 12.4990585,41.0864816 5.44744976,33.8598329 C-1.81581659,25.9947492 -1.81581659,13.8685612 5.44744976,6.00347756 C12.9491612,-1.69827958 23.4515573,-2.27341072 32.6036452,6.00347756 L100.019026,70.6432248 L167.4094,6.00347756 C176.6115,-2.29841646 187.08889,-1.69827958 194.590602,6.00347756 C201.850517,13.8602613 201.850517,25.9780434 194.590602,33.8348271 L194.590602,33.8598329 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarClosure);
export default __webpack_public_path__ + "static/media/sidebar-closure.1116998fbf2cdfce8ac7b5be1ba4ae13.svg";
export { ForwardRef as ReactComponent };